import { render } from "./new-plans.vue?vue&type=template&id=896008f4&scoped=true"
import script from "./new-plans.js?vue&type=script&lang=js&external"
export * from "./new-plans.js?vue&type=script&lang=js&external"

import "./new-plans.scss?vue&type=style&index=0&id=896008f4&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896008f4"]])

export default __exports__